import type { NextPage } from 'next';
import YeahComponent from '@components/projects/yeah/yeah';
import ProjectLayout from '@layouts/project-layout/project-layout';
import { Themes } from '@layouts/main-layout/themes.enum';
import { ProjectProps } from '@models/project.interface';

const Yeah: NextPage<ProjectProps> = (project) => {
  return (
    <ProjectLayout theme={Themes.Dark} project={project}>
      <YeahComponent breadcrumbsText={project.project.breadcrumbsText} />
    </ProjectLayout>
  );
};

export default Yeah;
export { getServerSideProps } from '@layouts/project-layout/project-layout';
